import type { DateFormatPattern } from '@onefootprint/core';

export { resolveBrowserDatePattern, toDateFormatPattern } from '@onefootprint/core';

export type DateMask = { date: true; delimiter: string; datePattern: string[]; placeholder: string };

export const dateMaskForPattern: Record<DateFormatPattern, DateMask> = {
  mdy: { date: true, delimiter: '/', datePattern: ['m', 'd', 'Y'], placeholder: 'MM/DD/YYYY' },
  dmy: { date: true, delimiter: '/', datePattern: ['d', 'm', 'Y'], placeholder: 'DD/MM/YYYY' },
  ymd: { date: true, delimiter: '-', datePattern: ['Y', 'm', 'd'], placeholder: 'YYYY-MM-DD' },
};
